import React from "react";
import { Card, Tooltip } from "antd";
import { HelpOutlineOutlined } from "@material-ui/icons";

const CountCard = (props) => {
  const title = (
    <>
      <span>{props.title}</span>
      <span className="ml-3">
        <Tooltip title={props.tooltip}>
          <HelpOutlineOutlined fontSize="small" />
        </Tooltip>
      </span>
    </>
  );
  return (
    <Card title={title} hoverable>
      {props.children}
    </Card>
  );
};

export default CountCard;
